export default __webpack_public_path__ + "static/media/menu_my_recordings.7431ab2b.svg";